module.exports = __webpack_public_path__ + "img/payments3.48004a16.jpg";